import React from 'react';

const FigmaLogo = () => {
  return (
    <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_189_223)">
      <path d="M2.00102 13.0008C3.10505 13.0008 4.00107 12.0299 4.00107 10.8337V8.6665H2.00102C0.896997 8.6665 0.000976562 9.63739 0.000976562 10.8337C0.000976562 12.0299 0.896997 13.0008 2.00102 13.0008Z" fill="#0ACF83"/>
      <path d="M0.000976562 6.50064C0.000976562 5.30438 0.896997 4.3335 2.00102 4.3335H4.00107V8.66779H2.00102C0.896997 8.66779 0.000976562 7.69691 0.000976562 6.50064Z" fill="#A259FF"/>
      <path d="M0.00146484 2.1669C0.00146484 0.970638 0.897485 -0.000244141 2.00151 -0.000244141H4.00155V4.33405H2.00151C0.897485 4.33405 0.00146484 3.36317 0.00146484 2.1669Z" fill="#F24E1E"/>
      <path d="M4 0H6.00004C7.10407 0 8.00009 0.970882 8.00009 2.16715C8.00009 3.36341 7.10407 4.3343 6.00004 4.3343H4V0Z" fill="#FF7262"/>
      <path d="M8.00009 6.50064C8.00009 7.69691 7.10407 8.66779 6.00004 8.66779C4.89602 8.66779 4 7.69691 4 6.50064C4 5.30438 4.89602 4.3335 6.00004 4.3335C7.10407 4.3335 8.00009 5.30438 8.00009 6.50064Z" fill="#1ABCFE"/>
      </g>
      <defs>
      <clipPath id="clip0_189_223">
      <rect width="8" height="13" fill="white"/>
      </clipPath>
      </defs>
    </svg>
  )
}

export default FigmaLogo;